import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User as FirebaseUser } from "firebase/auth";
import { User, UserPass } from "@/models/user";
import { CategorySlug } from "@/models/category";
import { Pass } from "@/models/pass";
import { Order } from "@/models/order";

type InitialState = {
  auth: AuthState;
  userData: User | undefined;
  passesData: Pass[];
  ordersData: Order[];
  selectedRouteName: string;
  isAppInit: boolean;
  isTagCreated: boolean;
  color: string;
  Loading: {
    isLoading: boolean;
    message: string;
  };
};

type AuthState = {
  isAuth: boolean;
  user?: FirebaseUser;
};

const initialState = {
  auth: {
    isAuth: false,
    user: undefined,
  } as AuthState,
  Loading: {
    isLoading: false,
    message: "",
  },
  userData: undefined,
  passesData: [],
  ordersData: [],
  selectedRouteName: "",
  isAppInit: false,
  isTagCreated: false,
  color: "",
} as InitialState;

export const appSlice = createSlice({
  name: "app",
  initialState: initialState,
  reducers: {
    logOut: (state) => {
      state.auth = initialState.auth;
      state.userData = initialState.userData;
      state.ordersData = [];
      state.isTagCreated = false;
    },
    logIn: (state, action: PayloadAction<FirebaseUser>) => {
      state.auth.isAuth = true;
      state.auth.user = action.payload;
    },
    tagCreated: (state, action: PayloadAction<boolean>) => {
      state.isTagCreated = true;
    },
    userDetails: (state, action: PayloadAction<User>) => {
      state.userData = action.payload;
    },
    setUserPasses: (state, action: PayloadAction<UserPass[]>) => {
      if (!!state.userData) {
        state.userData.passes = action.payload;
      }
    },
    setPassesData: (state, action: PayloadAction<Pass[]>) => {
      state.passesData = action.payload;
    },
    setOrdersData: (state, action: PayloadAction<Order[]>) => {
      state.ordersData = action.payload;
    },
    setSelectedRoute: (state, action: PayloadAction<string>) => {
      state.selectedRouteName = action.payload;
    },
    startLoader: (state, action: PayloadAction<string>) => {
      state.Loading.isLoading = true;
      state.Loading.message = action.payload ?? "";
    },
    stopLoader: (state) => {
      state.Loading.isLoading = false;
      state.Loading.message = "";
    },
    appInitialized: (state) => {
      state.isAppInit = true;
    },
  },
});

export const {
  logIn,
  logOut,
  userDetails,
  setUserPasses,
  setPassesData,
  setOrdersData,
  tagCreated,
  setSelectedRoute,
  startLoader,
  stopLoader,
  appInitialized,
} = appSlice.actions;
export default appSlice.reducer;
